import { render, staticRenderFns } from "./OrgFeesInvoicePage.vue?vue&type=template&id=405272f5"
import script from "./OrgFeesInvoicePage.vue?vue&type=script&lang=js"
export * from "./OrgFeesInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports